import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
const data = [{
  name: 'Independent',
  value: 120
}, {
  name: 'Assisted Living',
  value: 85
}, {
  name: 'Memory Care',
  value: 42
}];
const COLORS = ['#255db7', '#1f58b0', '#f97c6b', '#f6d052'];
export const ResidentDistributionChart: React.FC = () => {
  return <ResponsiveContainer width="100%" height="100%" data-id="element-57">
      <PieChart data-id="element-58">
        <Pie data={data} cx="50%" cy="50%" labelLine={false} outerRadius={80} fill="#8884d8" dataKey="value" label={({
        name,
        percent
      }) => `${name} ${(percent * 100).toFixed(0)}%`} data-id="element-59">
          {data.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-60" />)}
        </Pie>
        <Tooltip data-id="element-61" />
        <Legend data-id="element-62" />
      </PieChart>
    </ResponsiveContainer>;
};